export enum ExistingTelcoConnections {
  Krone_Blocks,
  Siemens_Blocks,
  ADC_Modules,
  Screwed,
  Soldered,
  Other,
}
